import React from 'react';
import { VerifiedCitation } from './citations';
import './panelReport.css';

// Only verified citations reach here — see citations.verifyCitations.
const ReferenceList: React.FC<{ citations: VerifiedCitation[] }> = ({ citations }) => (
	<ul className="mg-reference-list">
		{citations.map((entry) => (
			<li key={entry.index}>
				<div className="mg-reference-list__citation">
					{entry.url ? (
						<a href={entry.url} target="_blank" rel="noopener noreferrer" title="View on PubMed">
							{entry.citation}
						</a>
					) : (
						entry.citation
					)}
				</div>
				{entry.relevance && (
					<div className="mg-reference-list__relevance">{entry.relevance}</div>
				)}
			</li>
		))}
	</ul>
);

export default ReferenceList;
